/* Dhrivian Theme — Main JS */

(function() {
  'use strict';

  /* ===== Cart Drawer ===== */
  const CartDrawer = {
    overlay: null,

    open() {
      const el = document.getElementById('cart-drawer-overlay');
      if (el) {
        el.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    },

    close() {
      const el = document.getElementById('cart-drawer-overlay');
      if (el) {
        el.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    },

    formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = amount.split('.');
      var intPart = parts[0];
      var decPart = parts[1] ? '.' + parts[1] : '';
      // Indian grouping: last 3 digits, then groups of 2
      if (intPart.length > 3) {
        intPart = intPart.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + intPart.slice(-3);
      }
      return '₹' + intPart + decPart;
    },

    escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },

    // Mirrors snippets/bag-qty-stepper.liquid
    qtyStepperHtml(item) {
      var title = this.escapeHtml(item.product_title);
      return '<div class="qty-selector qty-selector--bag">' +
          '<button type="button" class="qty-selector__btn" data-cart-qty="' + item.key + '" data-cart-qty-delta="-1" aria-label="Decrease quantity of ' + title + '"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span class="qty-selector__value" data-cart-qty-val aria-label="Quantity">' + item.quantity + '</span>' +
          '<button type="button" class="qty-selector__btn" data-cart-qty="' + item.key + '" data-cart-qty-delta="1" aria-label="Increase quantity of ' + title + '">+</button>' +
        '</div>';
    },

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        var self = this;

        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.closest('[data-cart-count-bubble]')?.toggleAttribute('hidden', cart.item_count === 0);
        });

        var drawer = document.getElementById('cart-drawer-items');
        if (!drawer) return;

        var overlay = document.getElementById('cart-drawer-overlay');
        var cartDrawerEl = overlay ? overlay.querySelector('.cart-drawer') : null;

        // Remove the existing footer (it is re-added if the bag has items)
        if (cartDrawerEl) {
          var oldFooter = cartDrawerEl.querySelector('.cart-drawer__footer');
          if (oldFooter) oldFooter.remove();
        }

        if (cart.item_count === 0) {
          drawer.innerHTML =
            '<div class="cart-drawer__empty">' +
              '<div class="cart-drawer__empty-icon">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--color-subtle)" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
              '</div>' +
              '<p style="font-family:var(--font-head);font-weight:500;font-size:15px;color:var(--color-muted);margin-bottom:20px;">Your bag is empty</p>' +
              '<button class="btn btn--primary" data-cart-close>Continue Shopping</button>' +
            '</div>';
          return;
        }

        // Render items
        var itemsHtml = '';
        cart.items.forEach(function(item) {
          var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-drawer__item-variant">' + self.escapeHtml(item.variant_title) + '</p>' : '';
          itemsHtml +=
            '<div class="cart-drawer__item">' +
              '<img class="cart-drawer__item-image" src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="80" height="100" loading="lazy">' +
              '<div class="cart-drawer__item-details">' +
                '<h4 class="cart-drawer__item-title">' + item.product_title + '</h4>' +
                variantHtml +
                '<p class="cart-drawer__item-price">' + self.formatMoney(item.final_line_price) + '</p>' +
                '<div class="cart-drawer__item-actions">' +
                  self.qtyStepperHtml(item) +
                  '<button type="button" class="cart-drawer__item-remove" data-cart-remove="' + item.key + '">Remove</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        });
        drawer.innerHTML = itemsHtml;

        // Footer (shipping is free on every order)
        if (cartDrawerEl) {
          var footer = document.createElement('div');
          footer.className = 'cart-drawer__footer';
          footer.innerHTML =
            '<div class="cart-drawer__subtotal">' +
              '<span class="cart-drawer__subtotal-label">Subtotal</span>' +
              '<span class="cart-drawer__subtotal-value">' + self.formatMoney(cart.total_price) + '</span>' +
            '</div>' +
            '<div class="cart-drawer__shipping-line">' +
              '<span class="cart-drawer__shipping-label">Shipping</span>' +
              '<span class="cart-drawer__shipping-value">FREE</span>' +
            '</div>' +
            '<p class="cart-drawer__taxes-note">Inclusive of all taxes</p>' +
            '<a href="/checkout" class="cart-drawer__checkout">Checkout</a>' +
            '<div class="cart-drawer__payment-methods"><span>UPI</span><span>Cards</span><span>COD</span></div>';
          cartDrawerEl.appendChild(footer);
        }
      } catch (e) { console.error('Cart refresh failed', e); }
    },

    async addItem(formData) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.fromEntries(formData))
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await this.refresh();
        this.open();
      } catch (e) {
        console.error(e);
      }
    },

    async updateItem(key, quantity) {
      if (this.busy) return;
      this.busy = true;
      var drawerEl = document.getElementById('cart-drawer-items');
      if (drawerEl) drawerEl.setAttribute('aria-busy', 'true');
      var pageItems = document.getElementById('cart-page-items');
      if (pageItems) pageItems.setAttribute('aria-busy', 'true');
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        // On the /cart page, re-render the whole page so its totals update too.
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        await this.refresh();
        if (quantity === 0) {
          const cart = await (await fetch('/cart.js')).json();
          if (cart.item_count === 0) this.close();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.busy = false;
        var itemsEl = document.getElementById('cart-drawer-items');
        if (itemsEl) itemsEl.removeAttribute('aria-busy');
      }
    },

    init() {
      document.addEventListener('click', function(e) {
        const openBtn = e.target.closest('[data-cart-open]');
        // On the /cart page the bag is already on screen, so let the link load it.
        if (openBtn && document.querySelector('[data-cart-page]')) return;
        if (openBtn) { e.preventDefault(); CartDrawer.open(); return; }

        const closeBtn = e.target.closest('[data-cart-close]');
        if (closeBtn) { e.preventDefault(); CartDrawer.close(); return; }

        const backdrop = e.target.closest('[data-cart-backdrop]');
        if (backdrop && e.target === backdrop) { CartDrawer.close(); return; }

        const removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
          e.preventDefault();
          CartDrawer.updateItem(removeBtn.dataset.cartRemove, 0);
          return;
        }

        const qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          e.preventDefault();
          if (qtyBtn.disabled) return;
          var key = qtyBtn.dataset.cartQty;
          var delta = parseInt(qtyBtn.dataset.cartQtyDelta, 10);
          var display = qtyBtn.closest('.qty-selector')?.querySelector('[data-cart-qty-val]');
          var current = display ? parseInt(display.textContent, 10) : 1;
          // Never step below 1; "Remove" deletes the line.
          CartDrawer.updateItem(key, Math.max(1, (current || 1) + delta));
        }
      });

      document.addEventListener('submit', function(e) {
        var form = e.target.closest('form[data-add-to-cart]');
        if (form) {
          e.preventDefault();
          // No variant yet means no size chosen: prompt instead of adding.
          var idInput = form.querySelector('input[name="id"]');
          if (idInput && !idInput.value) {
            VariantSelector.promptSize();
            return;
          }
          var btn = form.querySelector('[type="submit"]');
          // Swap only the label so the icon and [data-atc-label] survive.
          var labelEl = (btn && btn.querySelector('[data-atc-label]')) || btn;
          var originalText = labelEl ? labelEl.textContent : '';
          if (labelEl) labelEl.textContent = 'Adding…';
          CartDrawer.addItem(new FormData(form)).then(function() {
            if (labelEl) {
              labelEl.textContent = 'Added!';
              setTimeout(function() { labelEl.textContent = originalText; }, 1500);
            }
          });
        }
      });
    }
  };

  /* ===== Announcement Bar ===== */
  const AnnouncementBar = {
    init() {
      var bar = document.querySelector('[data-announcement-bar]');
      if (!bar) return;
      var texts = bar.querySelectorAll('[data-announcement-text]');
      if (texts.length <= 1) return;
      var idx = 0;
      setInterval(function() {
        texts[idx].setAttribute('hidden', '');
        idx = (idx + 1) % texts.length;
        texts[idx].removeAttribute('hidden');
      }, 4000);
    }
  };

  /* ===== Mobile Nav ===== */
  const MobileNav = {
    open() {
      var el = document.getElementById('mobile-nav-overlay');
      if (el) {
        el.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    },

    close() {
      var el = document.getElementById('mobile-nav-overlay');
      if (el) {
        el.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    },

    init() {
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-mobile-nav-open]')) { e.preventDefault(); MobileNav.open(); }
        if (e.target.closest('[data-mobile-nav-close]')) { e.preventDefault(); MobileNav.close(); }
        var backdrop = e.target.closest('[data-mobile-nav-backdrop]');
        if (backdrop && e.target === backdrop) MobileNav.close();
      });
    }
  };

  /* ===== Search Overlay ===== */
  const SearchOverlay = {
    open() {
      var el = document.getElementById('search-overlay');
      if (el) {
        el.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        var input = el.querySelector('input[type="search"]');
        if (input) { input.value = ''; input.focus(); }
      }
    },

    close() {
      var el = document.getElementById('search-overlay');
      if (el) {
        el.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    },

    async search(query) {
      if (query.length < 2) {
        this.showSuggestions();
        return;
      }
      try {
        var res = await fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=6');
        var data = await res.json();
        this.renderResults(data.resources?.results || {});
      } catch (e) {
        console.error(e);
      }
    },

    showSuggestions() {
      var results = document.getElementById('search-results');
      var suggestions = document.getElementById('search-suggestions');
      if (results) results.setAttribute('hidden', '');
      if (suggestions) suggestions.removeAttribute('hidden');
    },

    renderResults(results) {
      var container = document.getElementById('search-results');
      var suggestions = document.getElementById('search-suggestions');
      if (!container) return;
      if (suggestions) suggestions.setAttribute('hidden', '');

      var products = results.products || [];
      if (products.length === 0) {
        container.innerHTML = '<div class="search-page__empty"><p style="font-weight:500;font-size:16px;color:var(--color-muted);">No results found</p></div>';
      } else {
        var html = '<div class="search-overlay__results">';
        products.forEach(function(p) {
          var img = p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '';
          // /search/suggest.json returns price in rupees ("949.00"), not paise like /cart.js
          var price = CartDrawer.formatMoney(Math.round(parseFloat(p.price) * 100));
          html += '<a href="' + p.url + '" style="text-decoration:none;transition:transform 0.3s;" class="product-card"><div class="product-card__image-wrap">' + img + '</div><div class="product-card__info"><h3 class="product-card__title">' + p.title + '</h3><span class="product-card__price">' + price + '</span></div></a>';
        });
        html += '</div>';
        container.innerHTML = html;
      }
      container.removeAttribute('hidden');
    },

    init() {
      var self = this;
      var debounceTimer;

      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-search-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-search-close]')) { e.preventDefault(); self.close(); }
      });

      document.addEventListener('input', function(e) {
        if (e.target.closest('[data-search-input]')) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function() {
            self.search(e.target.value.trim());
          }, 300);
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          var overlay = document.getElementById('search-overlay');
          if (overlay && !overlay.hasAttribute('hidden')) {
            self.close();
          }
        }
      });
    }
  };

  /* ===== Hero Slideshow ===== */
  const HeroSlideshow = {
    current: 0,
    total: 0,
    timer: null,

    goTo(idx) {
      var slides = document.querySelectorAll('[data-hero-slide]');
      var dots = document.querySelectorAll('[data-hero-dot]');
      if (slides.length === 0) return;

      this.current = ((idx % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, i) {
        s.classList.toggle('hero__slide--active', i === HeroSlideshow.current);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('hero__dot--active', i === HeroSlideshow.current);
      });
    },

    next() { this.goTo(this.current + 1); },
    prev() { this.goTo(this.current - 1); },

    startAuto() {
      var self = this;
      this.timer = setInterval(function() { self.next(); }, 5000);
    },

    stopAuto() { clearInterval(this.timer); },

    init() {
      var slides = document.querySelectorAll('[data-hero-slide]');
      if (slides.length === 0) return;
      this.total = slides.length;
      this.goTo(0);
      this.startAuto();

      var self = this;
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-hero-prev]')) { e.preventDefault(); self.stopAuto(); self.prev(); self.startAuto(); }
        if (e.target.closest('[data-hero-next]')) { e.preventDefault(); self.stopAuto(); self.next(); self.startAuto(); }
        var dot = e.target.closest('[data-hero-dot]');
        if (dot) {
          e.preventDefault();
          self.stopAuto();
          self.goTo(parseInt(dot.dataset.heroDot, 10));
          self.startAuto();
        }
      });
    }
  };

  /* ===== Filter Drawer (Mobile) ===== */
  const FilterDrawer = {
    open() {
      var el = document.getElementById('filter-drawer-overlay');
      if (el) {
        el.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    },

    close() {
      var el = document.getElementById('filter-drawer-overlay');
      if (el) {
        el.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    },

    init() {
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-filter-open]')) { e.preventDefault(); FilterDrawer.open(); }
        if (e.target.closest('[data-filter-close]')) { e.preventDefault(); FilterDrawer.close(); }
        var backdrop = e.target.closest('[data-filter-backdrop]');
        if (backdrop && e.target === backdrop) FilterDrawer.close();
      });
    }
  };

  /* ===== Collapsible Filter Groups ===== */
  const FilterCollapse = {
    init() {
      document.addEventListener('click', function(e) {
        var toggle = e.target.closest('[data-filter-collapse]');
        if (!toggle) return;
        var content = toggle.nextElementSibling;
        if (content) {
          var isHidden = content.hasAttribute('hidden');
          if (isHidden) content.removeAttribute('hidden');
          else content.setAttribute('hidden', '');
          var chevron = toggle.querySelector('svg');
          if (chevron) {
            var path = chevron.querySelector('path');
            if (path) {
              path.setAttribute('d', isHidden ? 'M18 15l-6-6-6 6' : 'M6 9l6 6 6-6');
            }
          }
        }
      });
    }
  };

  /* ===== FAQ Accordion ===== */
  const FaqAccordion = {
    init() {
      document.addEventListener('click', function(e) {
        var toggle = e.target.closest('.faq-item__toggle');
        if (!toggle) return;
        var item = toggle.closest('.faq-item');
        if (item) item.classList.toggle('faq-item--open');
      });
    }
  };

  /* ===== PDP Gallery ===== */
  const PdpGallery = {
    current: 0,

    /* Thumbs hidden by the colourway filter are skipped by prev/next. */
    visibleThumbs() {
      return Array.prototype.filter.call(
        document.querySelectorAll('[data-thumb-index]'),
        function(t) { return !t.hidden; }
      );
    },

    setMainImage(src) {
      var mainImg = document.querySelector('#pdp-main-image img');
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.srcset = '';
      }
    },

    goTo(idx) {
      var thumbs = this.visibleThumbs();
      if (thumbs.length === 0) return;
      this.current = ((idx % thumbs.length) + thumbs.length) % thumbs.length;
      var active = thumbs[this.current];
      this.setMainImage(active.dataset.fullSrc);
      document.querySelectorAll('[data-thumb-index]').forEach(function(t) {
        t.classList.toggle('pdp-gallery__thumb--active', t === active);
      });
    },

    /* Jump to the thumb serving this image; fall back to swapping the main image
       directly for products whose gallery has too few shots to render thumbs. */
    selectBySrc(src) {
      var thumbs = this.visibleThumbs();
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].dataset.fullSrc === src) {
          this.goTo(i);
          return;
        }
      }
      this.setMainImage(src);
    },

    /* Show only the shots belonging to one colourway. Thumbs carrying no colour
       code stay visible so uncoded galleries keep working. */
    filterByColorCode(code) {
      var thumbs = document.querySelectorAll('[data-thumb-index]');
      if (thumbs.length === 0) return;

      thumbs.forEach(function(t) {
        var thumbCode = t.dataset.colorCode;
        t.hidden = !!(code && thumbCode && thumbCode !== code);
      });

      var multiple = this.visibleThumbs().length > 1;
      ['[data-gallery-prev]', '[data-gallery-next]'].forEach(function(sel) {
        var btn = document.querySelector(sel);
        if (btn) btn.hidden = !multiple;
      });

      this.goTo(0);
    },

    init() {
      var self = this;
      document.addEventListener('click', function(e) {
        var thumb = e.target.closest('[data-thumb-index]');
        if (thumb) {
          e.preventDefault();
          var thumbs = self.visibleThumbs();
          var idx = thumbs.indexOf(thumb);
          if (idx !== -1) self.goTo(idx);
        }
        if (e.target.closest('[data-gallery-prev]')) {
          e.preventDefault();
          self.goTo(self.current - 1);
        }
        if (e.target.closest('[data-gallery-next]')) {
          e.preventDefault();
          self.goTo(self.current + 1);
        }
      });
    }
  };

  /* ===== PDP Tabs =====
     Desktop: tab row, one panel shown (.is-active). Mobile: each panel is an
     accordion (.is-open), toggled independently. CSS picks which class
     applies at each width. [L6] */
  const PdpTabs = {
    init() {
      document.addEventListener('click', function(e) {
        var tab = e.target.closest('[data-pdp-tab]');
        var acc = e.target.closest('[data-pdp-acc]');
        if (!tab && !acc) return;
        var container = (tab || acc).closest('[data-pdp-tabs]');
        if (!container) return;

        if (tab) {
          var tabId = tab.dataset.pdpTab;
          container.querySelectorAll('[data-pdp-tab]').forEach(function(t) {
            var on = t.dataset.pdpTab === tabId;
            t.classList.toggle('pdp-tabs__tab--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          container.querySelectorAll('[data-pdp-panel]').forEach(function(p) {
            p.classList.toggle('is-active', p.dataset.pdpPanel === tabId);
          });
          return;
        }

        var panel = acc.closest('[data-pdp-panel]');
        var open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        acc.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  };

  /* ===== Size Guide Modal =====
     Men/Women chart toggle and inches/cm toggle. Focus moves into the dialog,
     Tab is trapped inside it, and focus returns to the opener on close. [H7] */
  const SizeGuide = {
    opener: null,

    focusables(el) {
      return Array.prototype.filter.call(
        el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function(f) { return !f.disabled && f.offsetParent !== null; }
      );
    },

    open(opener) {
      var el = document.getElementById('size-guide-modal');
      if (!el) return;
      SizeGuide.opener = opener || document.activeElement;
      el.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var close = el.querySelector('[data-size-guide-close]');
      if (close) close.focus();
    },

    close() {
      var el = document.getElementById('size-guide-modal');
      if (!el || el.hasAttribute('hidden')) return;
      el.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (SizeGuide.opener && SizeGuide.opener.focus) SizeGuide.opener.focus();
      SizeGuide.opener = null;
    },

    setFit(el, fit) {
      el.querySelectorAll('[data-size-guide-fit]').forEach(function(b) {
        b.setAttribute('aria-pressed', b.dataset.sizeGuideFit === fit ? 'true' : 'false');
      });
      el.querySelectorAll('[data-size-guide-chart]').forEach(function(c) {
        c.toggleAttribute('hidden', c.dataset.sizeGuideChart !== fit);
      });
    },

    setUnit(el, unit) {
      el.dataset.unit = unit;
      el.querySelectorAll('[data-size-guide-unit]').forEach(function(b) {
        b.setAttribute('aria-pressed', b.dataset.sizeGuideUnit === unit ? 'true' : 'false');
      });
    },

    init() {
      document.addEventListener('click', function(e) {
        var opener = e.target.closest('[data-size-guide-open]');
        if (opener) { e.preventDefault(); SizeGuide.open(opener); return; }
        if (e.target.closest('[data-size-guide-close]')) { e.preventDefault(); SizeGuide.close(); return; }
        var modal = e.target.closest('[data-size-guide]');
        if (!modal) return;
        if (e.target === modal) { SizeGuide.close(); return; }
        var fit = e.target.closest('[data-size-guide-fit]');
        if (fit) SizeGuide.setFit(modal, fit.dataset.sizeGuideFit);
        var unit = e.target.closest('[data-size-guide-unit]');
        if (unit) SizeGuide.setUnit(modal, unit.dataset.sizeGuideUnit);
      });

      document.addEventListener('keydown', function(e) {
        var modal = document.getElementById('size-guide-modal');
        if (!modal || modal.hasAttribute('hidden')) return;
        if (e.key === 'Escape') { SizeGuide.close(); return; }
        if (e.key !== 'Tab') return;
        var f = SizeGuide.focusables(modal);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
          e.preventDefault(); first.focus();
        }
      });
    }
  };

  /* ===== Product Recommendations =====
     The section only has products when fetched from the recommendations
     endpoint, so fetch it and inject the result. Remove the whole section if
     no products come back (or the request fails). [H10] */
  const ProductRecommendations = {
    init() {
      document.querySelectorAll('[data-product-recommendations][data-url]').forEach(function(el) {
        var section = el.closest('.shopify-section') || el;
        fetch(el.dataset.url)
          .then(function(res) { if (!res.ok) throw new Error(res.status); return res.text(); })
          .then(function(text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('[data-product-recommendations]');
            if (fresh && fresh.querySelector('.product-card')) {
              el.innerHTML = fresh.innerHTML;
            } else {
              section.remove();
            }
          })
          .catch(function() { section.remove(); });
      });
    }
  };

  /* ===== PDP Variant Selector =====
     Resolves the colour + size selection to a real variant, then drives the
     variant id, price, availability, and gallery off it. */
  const VariantSelector = {
    root: null,
    variants: [],
    colorPos: 0,
    sizePos: 0,
    color: null,
    size: null,

    optionAt(variant, pos) {
      if (pos === 1) return variant.option1;
      if (pos === 2) return variant.option2;
      if (pos === 3) return variant.option3;
      return null;
    },

    /* First variant matching the selected options. Positions are 0 when the
       product has no such option, in which case that axis is ignored. */
    match(color, size) {
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        if (this.colorPos && this.optionAt(v, this.colorPos) !== color) continue;
        if (this.sizePos && this.optionAt(v, this.sizePos) !== size) continue;
        return v;
      }
      return null;
    },

    /* First variant of the colourway, preferring one in stock. Used for the
       price and image while no size is chosen. */
    matchColor(color) {
      var first = null;
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        if (this.colorPos && this.optionAt(v, this.colorPos) !== color) continue;
        if (v.available) return v;
        if (!first) first = v;
      }
      return first;
    },

    /* Pass null to clear the size selection. */
    setSizeButton(btn) {
      this.root.querySelectorAll('[data-size-select]').forEach(function(s) {
        s.classList.remove('pdp-size-btn--active');
        s.setAttribute('aria-pressed', 'false');
      });
      if (btn) {
        btn.classList.add('pdp-size-btn--active');
        btn.setAttribute('aria-pressed', 'true');
        this.clearSizeError();
      }
      this.size = btn ? btn.dataset.sizeSelect : null;
    },

    clearSizeError() {
      var err = this.root && this.root.querySelector('[data-size-error]');
      if (err) err.textContent = '';
      var group = this.root && this.root.querySelector('[data-size-group]');
      if (group) group.classList.remove('pdp-sizes--error');
    },

    /* Called when Add to Bag is pressed with no size chosen. */
    promptSize() {
      if (!this.root) return;
      var err = this.root.querySelector('[data-size-error]');
      if (err) err.textContent = err.dataset.message || 'Please select a size';
      var group = this.root.querySelector('[data-size-group]');
      if (group) {
        group.classList.add('pdp-sizes--error');
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        group.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        var first = group.querySelector('[data-size-select]:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      }
    },

    selectColor(swatch) {
      this.root.querySelectorAll('[data-color-swatch]').forEach(function(s) {
        s.classList.remove('pdp-swatch--active');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('pdp-swatch--active');
      swatch.setAttribute('aria-pressed', 'true');
      this.color = swatch.dataset.colorSwatch;

      /* A size in stock in one colour may be sold out in another. Clear it
         rather than silently picking a different size for the shopper. */
      if (this.sizePos && this.size) {
        var current = this.match(this.color, this.size);
        if (!current || !current.available) this.setSizeButton(null);
      }

      this.update(true);
    },

    update(pushUrl) {
      var self = this;
      var needsSize = !!(this.sizePos && !this.size);
      var variant = needsSize ? null : this.match(this.color, this.size);
      // What to show (price, image) when no size is chosen yet.
      var shown = needsSize ? this.matchColor(this.color) : variant;

      /* Availability is per colourway, so recompute every size on each change. */
      this.root.querySelectorAll('[data-size-select]').forEach(function(btn) {
        var candidate = self.match(self.color, btn.dataset.sizeSelect);
        var inStock = !!(candidate && candidate.available);
        btn.disabled = !inStock;
        btn.classList.toggle('pdp-size-btn--disabled', !inStock);
      });

      var label = document.getElementById('selected-color');
      if (label && this.color) label.textContent = this.color;

      var priceEl = this.root.querySelector('[data-pdp-price]');
      if (priceEl && shown) priceEl.textContent = shown.price;

      var compareEl = this.root.querySelector('[data-pdp-compare-price]');
      if (compareEl) {
        if (shown && shown.has_compare) {
          compareEl.textContent = shown.compare_at_price;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      /* With no size chosen the id stays empty so no default variant is
         submitted; the submit handler prompts for a size instead. */
      var input = this.root.querySelector('input[name="id"]');
      if (input) input.value = variant ? variant.id : '';

      var atc = this.root.querySelector('[data-atc-button]');
      var atcLabel = this.root.querySelector('[data-atc-label]');
      var labelText;
      var buyable;
      if (needsSize) {
        buyable = !!(shown && shown.available);
        labelText = buyable ? 'Add to Bag' : 'Sold Out';
      } else {
        buyable = !!(variant && variant.available);
        labelText = !variant ? 'Unavailable' : (variant.available ? 'Add to Bag' : 'Sold Out');
      }
      if (atc) atc.disabled = !buyable;
      if (atcLabel) atcLabel.textContent = labelText;


      /* Prefer the code off the variant image; fall back to the swatch's own so
         the gallery still filters when a colourway has no image attached. */
      var code = null;
      var activeSwatch = this.root.querySelector('[data-color-swatch].pdp-swatch--active');
      if (activeSwatch && activeSwatch.dataset.colorCode) code = activeSwatch.dataset.colorCode;
      if (shown && shown.image_code) code = shown.image_code;

      PdpGallery.filterByColorCode(code);
      if (shown && shown.image) PdpGallery.selectBySrc(shown.image);

      if (pushUrl && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          // Drop a stale ?variant= when the size was cleared.
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* non-fatal — selection still applied */ }
      }
    },

    init() {
      this.root = document.querySelector('[data-pdp-variant-picker]');
      if (!this.root) return;

      var json = document.getElementById('pdp-variant-json');
      if (json) {
        try {
          this.variants = JSON.parse(json.textContent) || [];
        } catch (e) {
          this.variants = [];
        }
      }
      if (this.variants.length === 0) return;

      this.colorPos = parseInt(this.root.dataset.colorPos, 10) || 0;
      this.sizePos = parseInt(this.root.dataset.sizePos, 10) || 0;

      var activeSwatch = this.root.querySelector('.pdp-swatch--active');
      this.color = activeSwatch ? activeSwatch.dataset.colorSwatch : null;
      var activeSize = this.root.querySelector('.pdp-size-btn--active');
      this.size = activeSize ? activeSize.dataset.sizeSelect : null;

      var self = this;
      this.root.addEventListener('click', function(e) {
        var swatch = e.target.closest('[data-color-swatch]');
        if (swatch) {
          e.preventDefault();
          self.selectColor(swatch);
          return;
        }
        var sizeBtn = e.target.closest('[data-size-select]');
        if (sizeBtn && !sizeBtn.disabled) {
          e.preventDefault();
          self.setSizeButton(sizeBtn);
          self.update(true);
        }
      });

      this.update(false);
    }
  };

  /* ===== PDP Sticky Add to Bag =====
     Mobile bottom bar shown while the main Add to Bag button is off screen.
     It mirrors the main price, label and disabled state, and its button submits
     the main form so validation and the bag drawer work identically. */
  const StickyAtc = {
    init() {
      var bar = document.querySelector('[data-sticky-atc]');
      var mainBtn = document.querySelector('[data-pdp-variant-picker] [data-atc-button]');
      if (!bar || !mainBtn) return;
      var form = mainBtn.closest('form');
      var btn = bar.querySelector('[data-sticky-atc-button]');
      var priceEl = bar.querySelector('[data-sticky-atc-price]');
      var mainPrice = document.querySelector('[data-pdp-price]');
      var mainLabel = mainBtn.querySelector('[data-atc-label]');
      var btnLabel = btn && (btn.querySelector('[data-sticky-atc-label]') || btn);

      function sync() {
        if (btn) {
          btn.disabled = mainBtn.disabled;
          // Mirror only the label text so the bar keeps its icon.
          if (mainLabel && btnLabel) btnLabel.textContent = mainLabel.textContent;
        }
        if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent;
      }
      sync();
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(sync);
        mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
        if (mainPrice) mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
      }

      if (btn && form) {
        btn.addEventListener('click', function() {
          if (btn.disabled) return;
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      }

      function setVisible(visible) {
        bar.classList.toggle('pdp-sticky-atc--visible', visible);
        document.body.classList.toggle('has-sticky-atc', visible);
        if (visible) {
          bar.removeAttribute('aria-hidden');
          bar.removeAttribute('inert');
        } else {
          bar.setAttribute('aria-hidden', 'true');
          bar.setAttribute('inert', '');
        }
      }

      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(entries) {
        setVisible(!entries[0].isIntersecting);
      }).observe(mainBtn);
    }
  };

  /* ===== Quantity Selector ===== */
  const QuantitySelector = {
    init() {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-qty-btn]');
        if (!btn) return;
        var container = btn.closest('.qty-selector');
        if (!container) return;
        var display = container.querySelector('[data-qty-value]');
        var input = container.querySelector('input[name="quantity"]');
        if (!display) return;
        var current = parseInt(display.textContent, 10);
        var delta = parseInt(btn.dataset.qtyBtn, 10);
        var next = Math.max(1, current + delta);
        display.textContent = next;
        if (input) input.value = next;
      });
    }
  };

  /* ===== Init ===== */
  document.addEventListener('DOMContentLoaded', function() {
    CartDrawer.init();
    AnnouncementBar.init();
    MobileNav.init();
    SearchOverlay.init();
    HeroSlideshow.init();
    FilterDrawer.init();
    FilterCollapse.init();
    FaqAccordion.init();
    PdpGallery.init();
    PdpTabs.init();
    SizeGuide.init();
    ProductRecommendations.init();
    VariantSelector.init();
    StickyAtc.init();
    QuantitySelector.init();
  });
})();
